Element.prototype.hide = function () {
    this.style.display = 'none';
};

Element.prototype.show = function () {
    this.style.display = 'block';
};

Element.prototype.visibility = function (visible) {
    this.style.visibility = visible ? 'visible' : 'hidden';
};

Element.prototype.toggle = function () {
    this.style.display === 'none' ? this.show() : this.hide();
};

Element.prototype.toggleDisable = function () {
    this.hasAttribute('disabled') ? this.removeAttribute('disabled') : this.setAttribute('disabled', 'disabled');
};

Element.prototype.addClass = function (className) {
    this.classList.add(className);
    return this;
};

Element.prototype.removeClass = function (className) {
    this.classList.remove(className);
    return this;
};

Element.prototype.hasClass = function (className) {
    return this.classList.contains(className);
};

Element.prototype.toggleClass = function (className) {
    this.classList.toggle(className);
    return this;
};

Element.prototype.modal = function (action) {
    if (action === 'show') {
        this.addClass('show').show();
        document.querySelector('body').style.overflow = 'hidden';
    } else {
        this.removeClass('show').hide();
        document.querySelector('body').style.overflow = 'auto';
    }

    return this;
};

Element.prototype.empty = function () {
  this.innerHTML = '';
  return this;
};

Element.prototype.remove = function() {
    this.parentNode.removeChild(this);
};

Element.prototype.multipleValues = function() {
    let opts = [], opt;

    for (let i = 0, len = this.options.length; i < len; i++) {
        opt = this.options[i];

        if (opt.selected) {
            opts.push(opt.value);
        }
    }

    return opts;
};

Element.prototype.css = function(name, value) {
    this.style[name] = value;
}

String.prototype.replaceAll = function(search, replace){
    return this.split(search).join(replace);
};
